import { FieldPath, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ICustomFieldComponentProps } from 'types'
import { ControlledInput } from 'components/ControlledFields/ControlledFormElements/ControlledInput/ControlledInput'
import { TooltipFieldWrapper } from 'components/TooltipFieldWrapper'

type FieldConfig = {
  name: string
  label: string
  tooltip?: string
  placeholder?: string
}

type CreditCardProcessingFieldsProps = ICustomFieldComponentProps<
  FieldValues,
  FieldPath<FieldValues>,
  {
    fields?: FieldConfig[]
  }
>

const PercentIcon = () => <span className="text-sm text-gray-500">%</span>

export const CreditCardProcessingFields = ({
  fields = [],
  placeholder
}: CreditCardProcessingFieldsProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1">
      <span className="text-base font-semibold">
        {t('businessActivity.fields.creditCardProcessingMethods.label')}
      </span>
      <div className="flex flex-col gap-2">
        {fields.map(field => (
          <TooltipFieldWrapper
            key={field.name}
            label={field.label}
            tooltipText={field.tooltip}
          >
            <ControlledInput
              name={field.name}
              label={field.label}
              htmlType="number"
              placeholder={field.placeholder ?? placeholder}
              icon={<PercentIcon />}
            />
          </TooltipFieldWrapper>
        ))}
      </div>
    </div>
  )
}
